import { OperatorsState, OperatorsTypes } from './types';

const INITIAL_STATE: OperatorsState = {
  operatorData: { id: '' },
  operatorCreated: { id: '' },
  operatorsList: [],
  operatorSelected: { id: '' },
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line no-prototype-builtins
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Operators
const listOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  operatorsList: INITIAL_STATE.operatorsList,
});

const listOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  operatorsList: action.payload.operatorsList,
});

const listOperatorFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  operatorsList: INITIAL_STATE.operatorsList,
});

// Create Operators
const createOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  operatorCreated: INITIAL_STATE.operatorCreated,
});

const createOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  operatorCreated: action.payload.operatorCreated,
});

const createOperatorFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  operatorCreated: INITIAL_STATE.operatorCreated,
});

// Update Operators
const updateOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateOperatorFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Create Selected
const selectOperatorRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  operatorSelected: INITIAL_STATE.operatorSelected,
});

const selectOperatorSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  operatorSelected: action.payload.operatorSelected,
});

const selectOperatorFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  operatorSelected: INITIAL_STATE.operatorSelected,
});

const reducer = createReducer(INITIAL_STATE, {
  [OperatorsTypes.LIST_OPERATOR_REQUEST]: listOperatorRequest,
  [OperatorsTypes.LIST_OPERATOR_SUCCESS]: listOperatorSuccess,
  [OperatorsTypes.LIST_OPERATOR_FAILURE]: listOperatorFailure,
  [OperatorsTypes.CREATE_OPERATOR_REQUEST]: createOperatorRequest,
  [OperatorsTypes.CREATE_OPERATOR_SUCCESS]: createOperatorSuccess,
  [OperatorsTypes.CREATE_OPERATOR_FAILURE]: createOperatorFailure,
  [OperatorsTypes.UPDATE_OPERATOR_REQUEST]: updateOperatorRequest,
  [OperatorsTypes.UPDATE_OPERATOR_SUCCESS]: updateOperatorSuccess,
  [OperatorsTypes.UPDATE_OPERATOR_FAILURE]: updateOperatorFailure,
  [OperatorsTypes.SELECT_OPERATOR_REQUEST]: selectOperatorRequest,
  [OperatorsTypes.SELECT_OPERATOR_SUCCESS]: selectOperatorSuccess,
  [OperatorsTypes.SELECT_OPERATOR_FAILURE]: selectOperatorFailure,
});

export default reducer;
